var refError = function refError() {
  return new ReferenceError("this hasn't been initialised - super() hasn't been called");
};

export default refError;